'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedIconIcon = function EmbedIconIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M4.313 15.813l5.75-5.75-2.125-2.125L0 15.813l7.938 7.938 2.125-2.125zM25.188 9l-1.125-1.063-2.125 2.125 1.125 1.063 4.625 4.688-5.75 5.813 2.125 2.125 7.938-7.938zm-10.25 17.75h-3l5.563-21.5h3z' })
    );
};

exports.default = EmbedIconIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/EmbedIconIcon.js
// module id = 631
// module chunks = 0